export default "__VITE_ASSET__490b00d3__"